import ImageGalleryResponsiveFullscreenImage from './ImageGalleryResponsiveFullscreenImage';

export default ImageGalleryResponsiveFullscreenImage;
